import React, { useContext } from "react";
import "../Styles/SelectThemes.css";
import { ThemeContext } from "../../../../../context/ThemeContext"; // Import the global theme context

const ThemeSelector = () => {
  const { theme, setTheme } = useContext(ThemeContext); // Get theme from context

  return (
    <div className="st-select-theme-container">
      <label className= "st-text-label" >Select Theme:</label>
      <select
        value={theme}
        onChange={(e) => setTheme(e.target.value)} // Update global theme
        className="st-themes-dropdown"
        style={{background: "gray"}}
      >
        <option value="desertTitanium">Desert Titanium</option>
        <option value="shinyBlack">Shiny Black</option>
        <option value="milkyWhite">Milky White</option>
      </select>
    </div>
  );
};

export default ThemeSelector;
